import { render, staticRenderFns } from "./PersonalizeForm.vue?vue&type=template&id=8f66a542&"
import script from "./PersonalizeForm.vue?vue&type=script&lang=js&"
export * from "./PersonalizeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports